<template>
  <div class="main">
    <div class="banner">
      <el-carousel :height="cHeight" :interval="5000" v-if="!$store.state.isMB">
        <el-carousel-item v-for="item in carouselList" :key="item.title">
          <img :src="$store.state.isMB? item.mburl : item.pcurl" alt="" height="100%" ref="imgCon">
          <div class="textNtitle">
            <span class="banner_title">{{item.title}}</span><br>
            <div class="banner_text">{{item.text}}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white" v-else>
        <van-swipe-item v-for="item in carouselList" :key="item.title">
          <img :src="$store.state.isMB? item.mburl:item.pcurl" alt="" ref="imgCon">
          <div class="textNtitle">
            <span class="banner_title">{{item.title}}</span><br>
            <div class="banner_text">{{item.text}}</div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="experience">
      <div class="info_title">
          <span>经验沉淀，创新发展</span>
      </div>
      <div class="explain">聚焦市场动态、执着客户需求，贴合行业客户需求，提供适配业务场景的定制化解决方案与配套服务，致力成为全球领先的汽车与保险产业信息技术解决方案服务商</div>
      <img src="static/images/index/bn.png" :width="$store.state.isMB?'37%':''" class="toKnow" alt="" @click="toAbout">
      <div class="programer">
        <div class="basics">
          <img src="static/images/index/icon1.png" alt="">
          <ul>核心服务能力
            <li>汽车数据</li>
            <li>开发平台</li>
          </ul>
          </div>
        <div class="basics">
          <img src="static/images/index/icon2.png" alt="">
          <ul>保险行业(多险种)
            <li>定损核损产品</li>
            <li>价格管理</li>
            <li>在线理赔平台</li>
            <li>理赔协作管理平台</li>
            <li>可视化分析</li>
          </ul>
        </div>
        <div class="basics">
          <img src="static/images/index/icon3.png" alt="">
          <ul>汽车后市场
            <li>易通配</li>
            <li>汽配管理系统</li>
            <li>维修厂管理系统</li>
            <li>整车残值拍卖管理</li>
            <li>配件修复回收管理平台</li>
          </ul>
        </div>
        <div class="basics">
          <img src="static/images/index/icon4.png" alt="">
          <ul>医疗健康
            <li>智慧医疗健康管理</li>
            <li>汽智慧医疗人伤系统</li>
            <li>医疗诊疗数据</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="technology">
      <div class="info_title">
          <span>以技术能力赋能各行业数字化转型升级</span>
      </div>
      <div class="explain">协助企业快速洞察行业趋势，提供涵盖业务平台建设、数据、业务咨询分析，专业培训一体化的服务解决方案。
      </div>
      <div class="tecContect">
        <div class="comInfo">
          <div class="tec" v-for="(item, index) in tecList" :class="item.showContent?'showContent':''" :key="item.tecName" @mouseenter="tecChange(index)">
            {{item.tecName}}
          </div>
        </div>
        <div class="content">
          <div class="conTitle">{{conTitle}}</div>
          <div class="conText">{{conText}}</div>
        </div>
        <div class="moreLink"> 
          <img class="knowMore" src="static/images/index/btn.png" alt="" @click="toPage">
          <span class="kmText" @click="toPage">了解更多</span>
        </div>
        <img class="tecImg" :src="$store.state.isMB?'static/mbimages/index/tec_img.jpg':'static/images/index/tec_img.png'" alt="">
      </div>
    </div>
    <div class="servies">
      <div class="info_title">
          <span>专业咨询，服务周到</span>
      </div>
      <div class="serviesInfo">
        <div class="serviesContent">
          <div class="serviesTitle">丰富的解决方案</div>
          <div class="serviesText">团队多年打造的数据平台和技术平台能力，十年磨一剑，深知系统平台构建过程所必须要躲避的问题。东升集合团队十年的建设经验和能力，就是这样一套具备成熟的数据服务与平台搭建能力，为客户提供稳定可靠的数字化解决方案。</div>
        </div>
        <div class="serviesContent">
          <div class="serviesTitle">专业的服务团队</div>
          <div class="serviesText">资深架构师提供售前技术方案咨询，行业前沿的动态辅助您进行需求梳理和模式构建设计，技术支持团队系统的顺利对接和上线，提供专业的项目过程管理，完善的客户服务队伍提供可信赖的服务。</div>
        </div>
        <div class="serviesContent">
          <div class="serviesTitle">及时的服务响应</div>
          <div class="serviesText">建立专属项目对接服务机制，保障全周期及时沟通响应，东升的每个项目有专属微信服务群，技术支持人员在项目的整个生命周期提供给您及时、专属的需求沟通和问题解答。一切的努力，只为让您所设计的业务模式发挥价值。</div>
        </div>
      </div>
    </div>
    <div class="company">
      <div class="info_title">
          <span>合作伙伴及客户</span>
      </div>
      <div class="companyList">
        <img width="215px" v-for="url in urlList" :src="url" :key="url" alt="">
      </div>
    </div>
    <div class="contact">
      <div class="contactUs">
        <div class="workfor">
          <span>致力于为保险与汽车行业提供专业解决方案</span><br>
          <span>留下您的联系方式，我们将第一时间与您联系</span>
        </div>
        <input placeholder="请输入您的联系方式">
        <div class="getProgramme">获取方案</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tecList: [
        { tecName: '核心能力', showContent: true, url: '/ability' },
        { tecName: '保险行业', showContent: false, url: '/insurance' },
        { tecName: '汽车后市场', showContent: false, url: '/aftermarket'},
        { tecName: '医疗健康', showContent: false }
      ],
      conTitle: '',
      conText: '',
      urlList: [
        'static/images/index/companies/picc.png',
        'static/images/index/companies/renshou.png',
        'static/images/index/companies/taiping.png',
        'static/images/index/companies/huatai.png',
        'static/images/index/companies/zhongyin.png',
        'static/images/index/companies/yingda.png'
      ],
      carouselList: [
        { pcurl: 'static/images/index/banner1.png', mburl: 'static/mbimages/index/banner1.jpg', title: '开发平台，释放平台多元技术能力', text: '东升自研开发平台，构建统一设计开发过程，以高效、经济、安全为核心理念搭建统一标准化开发流程，实现平台资产化管理构建' },
        { pcurl: 'static/images/index/banner2.png', mburl: 'static/mbimages/index/banner2.jpg', title: '助力保险行业提升服务能力', text: '助力保险行业梳理业务流程，提升业务可视度，优化理赔与企业运营管控效率，帮助客户合理管控经营成本' },
        { pcurl: 'static/images/index/banner3.png', mburl: 'static/mbimages/index/banner3.jpg', title: '助力汽车后市场提升运营能力', text: '深耕汽车后市场，为客户提供信息技术与服务支持，打通产业上下游协同链路，完善全流程服务体系，共建良性产业协作生态。' }
      ],
      cHeight: document.body.offsetWidth < 768 ? document.body.offsetWidth / 750 * 600 + 'px' : document.body.offsetWidth / 1900 * 600 + 'px'
    }
  },
  mounted() {
    this.tecChange(0)
    window.scroll(0,0)
  },
  methods: {
    tecChange (index) {
      let tec = this.tecList
      if (!tec[index].showContent) {
        for (var i in tec) {
          if (i == index) {
            tec[i].showContent = true
          } else {
            tec[i].showContent = false
          }
        }
      }
      switch (index) {
        case 0:
          this.conTitle = '基础能力解决方案'
          this.conText = '东升公司具有汽车后市场零配件贸易、保险公估、零配件回收与再制造的实体服务为依托，协助企业快速洞察行业趋势，提供涵盖业务平台建设、数据、业务咨询分析，专业培训一体化的服务解决方案。'
        break;
        case 1:
          this.conTitle = '保险行业解决方案'
          this.conText = '提供车险服务相关的产品，以助力企业打通理赔全流程可视链路，优化内部作业流转效率，辅助管控理赔风险与经营支出，完善客户理赔服务体系'
        break;
        case 2:
          this.conTitle = '汽车后市场解决方案'
          this.conText = '深耕汽车后市场，为客户提供信息技术与服务支持，打通产业上下游协同链路，完善全流程服务体系，共建良性产业协作生态'
        break;
        case 3:
          this.conTitle = '医疗健康解决方案'
          this.conText = '构建可持续发展的健康生态系统，为医疗健康事业创造价值，推动信息技术与行业的结合，创新行业模式'
        break;
      }
    },
    toPage () {
      for (var i in this.tecList) {
        if (this.tecList[i].showContent && this.tecList[i].url) {
          this.$router.push(this.tecList[i].url)
          return
        }
      }
    },
    toAbout () {
      this.$router.push('/about')
    }
  }
}
</script>
<style lang="scss" scoped>
.main{
  .banner{
    .textNtitle{
      @media screen and (max-width: 767px){
        top: 28%;
        left: 6%;
      }
    }
    .banner_title{
      @media screen and (max-width: 356px){
        font-size: 20px;
      }
      @media screen and (max-width: 767px){
        letter-spacing: 1px;
      }
    }
    .banner_text{
      @media screen and (min-width: 768px){
        width: 690px;
        font-size: 18px;
      } 
      @media screen and (max-width: 767px){
        margin-top: 3%;
      }
    }
    .van-swipe-item {
      position: relative;
    }
  }
  .experience{
    background: url('../../static/images/index/bg1.png') no-repeat;
    background-size: 100% 100%;
    text-align: center;
    height: 828px;
    padding-top: 91px;
    @media screen and (max-width: 767px){
      background: none;
      height: fit-content;
      padding: 50px 4% 50px;
    }
    .toKnow{
      margin: 45px 0 50px;
      cursor: pointer;
      @media screen and (max-width: 767px){
        margin: 30px 0 40px;
      }
    }
    .programer{
      display: flex;
      width: 1200px;
      justify-content: space-between;
      margin: auto;
      flex-wrap: wrap;
      @media screen and (max-width: 767px){
        width: 100%;
      }
      ul{
        font-size: 16px;
        letter-spacing: 3px;
        padding-left: 0px;
        li {
          list-style: none;
          color: #666;
          font-size: 14px;
          margin-top: 5px;
          @media screen and (max-width: 767px){
            letter-spacing: 1px;
          }
        }
        li:nth-of-type(1){
          margin-top: 18px;
        }
      }
      .basics{
        width: 277px;
        height: 410px;
        background: #fff;
        box-shadow: 0px 0px 3px #ddd;
        @media screen and (max-width: 767px){
          width: 47.5%;
          padding: 0 1% 0;
          height: 360px;
        }
        @media screen and (max-width: 357px){
          height: 390px;
        }
      }
      .basics:nth-of-type(1){
        padding-top: 50px;
        margin-bottom: 36px;
        @media screen and (max-width: 767px){
          padding-top: 25px;
        }
        img{
          margin-bottom: 26px;
        }
      }
      .basics:nth-of-type(2){
        padding-top: 60px;
        @media screen and (max-width: 767px){
          padding-top: 36px;
        }
        img{
          margin-bottom: 33px;
        }
      }
      .basics:nth-of-type(3){
        padding-top: 63px;
        @media screen and (max-width: 767px){
          padding-top: 33px;
        }
        img{
          margin-bottom: 37px;
          @media screen and (max-width: 767px){
            margin-bottom: 34px;
          }
        }
      }
      .basics:nth-of-type(4){
        padding-top: 52px;
        @media screen and (max-width: 767px){
          padding-top: 20px;
        }
        img{
          margin-bottom: 32px;
        }
      }
    }
  }
  .technology{
    background: url('../../static/images/index/bg2.png') no-repeat;
    background-size: 100% 100%;
    height: 859px;
    color: #fff;
    padding-top: 91px;
    text-align: center;
    position: relative;
    @media screen and (max-width: 767px){
      background: url('../../static/mbimages/index/bg2.jpg') no-repeat;
      background-size: 100% 100%;
      height: fit-content;
    }
    .info_title,.info_title_MB{
      border-color: #fff;
    }
    .tecContect{
      width: 1200px;
      margin: 73px auto 0;
      height: 340px;
      position: relative;
      @media screen and (max-width: 767px){
        width: 100%;
        margin-top: 50px;
        height: fit-content;
        padding-bottom: 50px;
      }
      .comInfo{
        height: 66px;
        @media screen and (max-width: 767px){
          display: flex;
          justify-content: center;
        }
        .tec{
          float: left;
          width: 300px;
          height: 66px;
          line-height: 66px;
          background: rgba(0,0,0,0.3);
          @media screen and (max-width: 767px){
            width: 23%;
            float: none;
            height: 56px;
            line-height: 56px;
            white-space: nowrap;
          }
          @media screen and (max-width: 330px){
            font-size: 14px;
          }
        }
        .showContent{
          background: rgb(110,35,74);
        }
      }
      .content{
        width: 630px;
        text-align: left;
        margin-top: 52px;
        letter-spacing: 2px;
        @media screen and (max-width: 767px){
          width: 100%;
          padding: 0 3% 0 4%;
          margin-top: 40px;
          font-size: 14px;
        }
        .conTitle{
          font-size: 34px;
          margin-bottom: 38px;
          letter-spacing: 3px;
          @media screen and (max-width: 767px){
            font-size: 26px;
            margin-bottom: 26px;
          }
        }
      }
      .tecImg{
        position: absolute;
        top: 130px;
        right: 0;
        @media screen and (max-width: 767px){
          position: static;
          width: 92%;
          margin-top: 50px;
        }
      }
      .moreLink{
        position: relative;
        width: fit-content;
        @media screen and (max-width: 767px){
          width: 96%;
          margin: 50px 0 0 4%;
        }
        @media screen and (min-width: 768px){
          position: absolute;
          top: 400px;
        }
        .knowMore{
        cursor: pointer;
        display: block;
        @media screen and (max-width: 767px){
          width: 140px;
        }
          &:hover{
            opacity: 0.85;
          }
        }
        .kmText{
          cursor: pointer;
          letter-spacing: 2px;
          position: absolute;
          left: 35px;
          top: 20px;
          font-size: 18px;
          @media screen and (max-width: 767px){
            left: 5%;
            top: 25%;
            font-size: 14px;
          }
        }
      }
    }
  }
  .servies{
    padding-top: 91px;
    height: 700px;
    background: url('../../static/images/index/bg3.png') no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 767px){
      background: none;
      height: fit-content;
      padding-bottom: 50px;
      padding-top: 44px;
    }
    .serviesInfo{
      width: 1200px;
      display: flex;
      margin: auto;
      @media screen and (max-width: 767px){
        width: 100%;
        justify-content: center;
        flex-wrap: wrap;
      }
      .serviesContent{
        width: 400px;
        height: 380px;
        margin-top: 84px;
        text-align: left;
        color: #fff;
        letter-spacing: 2px;
        padding: 0 46px;
        @media screen and (max-width: 767px){
          width: 92%;
          margin-top: 43px;
          padding: 0 7.2% 38px;
          height: fit-content;
        }
        .serviesTitle{
          font-size: 22px;
          margin: 90px 0 45px;
          letter-spacing: 3px;
          text-align: center;
          @media screen and (max-width: 767px){
            margin: 24px 0 22px;
          }
        }
        .serviesText{
          line-height: 28px;
          font-size: 14px;
        }
      }
      .serviesContent:nth-of-type(1){
        background: url('../../static/images/index/fw1.png') no-repeat;
        @media screen and (max-width: 767px){
          background: url('../../static/mbimages/index/fw1.jpg') no-repeat;
        }
        background-size: 100% 100%;
      }
      .serviesContent:nth-of-type(2){
        background: url('../../static/images/index/fw2.png') no-repeat;
        @media screen and (max-width: 767px){
          background: url('../../static/mbimages/index/fw2.jpg') no-repeat;
        }
        background-size: 100% 100%;
      }
      .serviesContent:nth-of-type(3){
        background: url('../../static/images/index/fw3.png') no-repeat;
        @media screen and (max-width: 767px){
          background: url('../../static/mbimages/index/fw3.jpg') no-repeat;
        }
        background-size: 100% 100%;
      }
    }
  }
  .company{
    padding: 91px 0 55px;
    background: rgb(245, 245, 245);
    @media screen and (max-width: 767px){
      padding: 44px 4% 55px;
    }
    .info_title{
      margin-bottom: 97px;
      width: 260px;
      @media screen and (max-width: 767px){
        margin-bottom: 45px;
        width: 200px;
      }
    }
    .companyList{
      width: 1200px;
      margin: auto;
      display: flex;
      flex-wrap: wrap;
      @media screen and (max-width: 767px){
        width: 100%;
        justify-content: space-between;
      }
      img{
        margin: 0 31.25px 40px 0;
        @media screen and (max-width: 767px){
          width: 28.2%;
          height: 10.49vw;
          margin: 0 0 19px 0;
        }
      }
      img:nth-of-type(5){
        margin-right: 0;
      }
    }
  }
  .contact{
    height: 340px;
    background: url('../../static/images/index/bg4.png') no-repeat;
    background-size: 100% 100%;
    padding: 0;
    @media screen and (max-width: 767px){
      background: url('../../static/mbimages/index/bg4.jpg') no-repeat;
      height: 71.6vw;
      padding: 0 4%;
    }
    .contactUs{
      width: 980px;
      margin: auto;
      position: relative;
      @media screen and (max-width: 767px){
        width: 100%;
        height: 100%;
      }
      .workfor{
        letter-spacing: 2px;
        font-size: 30px;
        width: 360px;
        color: #fff;
        line-height: 48px;
        padding-top: 105px;
        @media screen and (max-width: 767px){
          width: 80%;
          padding-top: 14%;
          font-size: 24px;
          line-height: 36px;
        }
        @media screen and (max-width: 353px){
          width: 90%;
          font-size: 20px;
        }
        span:nth-of-type(2){
          font-size: 16px;
          white-space: nowrap;
          @media screen and (max-width: 767px){
            font-size: 12px;
            line-height: 18px;
            display: block;
            margin-top: 8%;
          }
        }
      }
      input, .getProgramme{
        position: absolute;
        height: 56px;
        line-height: 56px;
        right: 0;
        top: 142px;
        letter-spacing: 2px;
        border-radius: 30px;
        @media screen and (max-width: 767px){
          top: 70%;
        }
      }
      input{
        width: 480px;
        outline: none;
        border: none;
        padding: 0 160px 0 40px;
        @media screen and (max-width: 767px){
          width: 100%;
          height: 40px;
          padding: 0 33% 0 6%;
        }
      }
      .getProgramme{
        background: red;
        color: #fff;
        width: 150px;
        text-align: center;
        cursor: pointer;
        @media screen and (max-width: 767px){
          width: 28.93%;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
        }
        &:hover{
          color: #eee;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue